import { Button, Upload, message } from "antd"
import styles from "./index.module.scss"
import { useCallback, useMemo, useContext, useState, useRef } from "react"
import Utils from '@utils/utils';
import SampleModal from '../SampleModal'
import { BATCH_IMAGES_TYPE } from '@utils/CONST';
import { AppContext } from '@utils/AppContext';
import PSAIModal from '@PSAIComponents/PSAIModal';
import PickFromProject from './PickFromProject';


export default function UploadBox(props) {
    const { projectType, onUpload, onMyProjectUpload } = props
    const { globalUser } = useContext(AppContext)

    const [open, setOpen] = useState(false)

    const onPickImage = () => {
        const status = Utils.checkLoginStatus(() => onPickImage())
        if (!status) return
        setOpen(true)
    }

    const uploadDebounce = useCallback(_.debounce(async (_, fileList) => {
        if (props.setUploadOpen) props.setUploadOpen(false) // 关闭追加商品弹窗
        onUpload(_, fileList)
    }, 100), [])
    const beforeUpload = async (file, fileList) => {
        console.log('===beforeUpload===')
        uploadDebounce(file, fileList)
        return false
    }
    const handleDrop = async (e) => {
        e.stopPropagation()
        if ("getFilesAndDirectories" in e.dataTransfer) {
            const filesAndDirs = await e.dataTransfer.getFilesAndDirectories()
            const fileList = await Utils.getFilesFromDirs(filesAndDirs, "/")
            console.log('===handleDrop===')
            uploadDebounce(fileList[0], fileList)
            return false
        }
    }

    const commodityType = useMemo(() => {
        return projectType === BATCH_IMAGES_TYPE.TRYON_BATCH || projectType === BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH
    }, [projectType])
    const UploadText = useMemo(() => {
        return projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ? '批量上传商品图' :
            projectType === BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? '批量上传主商品图' :
                projectType === BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH ? '批量上传源素材' :
                    projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ? '上传1-10张穿搭商品图'
                        : '批量上传模特图'
    }, [projectType])

    const selectClick = (e) => {
        e.stopPropagation()
        onPickImage()
    }

    const projectListRef = useRef(null)
    const handleOk = async () => {
        const urlList = await projectListRef.current.onSubmit()
        if (!urlList || urlList.length === 0) return message.error('请至少选择一张图片')
        onMyProjectUpload(urlList, setOpen)
    }

    return (
        <div className={styles.Container}>
            <Upload.Dragger
                className={styles.Uploader}
                accept='image/jpeg,image/png,image/webp,image/avif'
                listType="picture-card"
                showUploadList={false}
                multiple
                beforeUpload={beforeUpload}
                onDrop={handleDrop}
            >
                <div className={styles.UploaderContent}>
                    <img src={"https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/" + (commodityType ? 'uploadCommidityIcon.png' : 'uploadModelIcon.png')} alt="" />
                    {projectType === BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? <span>将图片拖拽至此区域上传图片，仅支持上传透明背景PNG图
                        {/* <span
                            style={{ color: '#006EFF', textDecoration: 'underline', marginLeft: '8px' }}
                            onClick={(e) => {
                                e.stopPropagation()
                                navigate("/home/image_extraction")
                            }}
                        >去智能抠图处理</span> */}
                    </span> :
                        <span>将图片拖拽至此区域上传图片</span>}
                    {
                        projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ?
                            <>
                                <Button type="primary" className={styles.UploadBtn2}>{UploadText}</Button>
                                <Button onClick={(e) => selectClick(e)} className={styles.UploadBtn3}>去【我的项目】中选图</Button>
                            </> :
                            <Button type="primary" className={styles.UploadBtn}>{UploadText}</Button>
                    }
                </div>
            </Upload.Dragger>
            {
                projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ?
                    <div className={styles.UploadTips_smart}>
                        <p>图片上传说明：</p>
                        <p>1. 一个项目最多上传{globalUser?.membership?.concurrentSku || 50}件商品</p>
                        <p>2. 单张详情图片尺寸不超出<span>10000*10000px</span>，大小不超过<span>40M</span>，支持jpg/jpeg/png格式图片</p>
                        <p>3. 一组商品需要<span>上传10-50张详情页图片</span>，图片越多效果越好，图片过少生成的详情页会产生大量重复内容</p>
                    </div> :
                    <div className={styles.UploadTips}>
                        <p>图片上传说明：</p>
                        <p>{projectType != BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH &&
                            `一个项目最多上传${globalUser?.membership?.concurrentSku || 50}件商品，每张上传图视为一件商品，`}图片小于等于30M，分辨率不小于500*500px</p>
                        <SampleModal showValue={projectType} />
                    </div>
            }

            <PSAIModal
                open={open}
                maxWidth={1064}
                title="选择图片"
                cancelButtonProps={{ style: { width: '200px', marginTop: '16px' } }}
                okButtonProps={{ style: { width: '200px', marginTop: '16px' } }}
                onOk={handleOk}
                onCancel={() => setOpen(false)}
            >
                <PickFromProject
                    ref={projectListRef}
                    useImageType
                />
            </PSAIModal>
        </div>
    )
}